import { useContext } from 'react';
import ToastsContext, { ToastContextType } from './toasts-context';

export default function useToasts(): ToastContextType {
  return useContext(ToastsContext);
}
